<div class="classic-container">
  <app-menu [class.hide]="showGameComponent"></app-menu>
  <app-classic-game [class.hide]="!showGameComponent"></app-classic-game>
</div>
<app-live-messages
  [messages]="classicMessages"
  [type]="liveMessageTypeEnum.CLASSIC"
  [isAdmin]="false"
></app-live-messages>
